import React from 'react';
import { Grid, TextField } from '@mui/material';
import { ItemOfertaData } from '../../../types';

export const OBSERVACIONES_MAX_LENGTH = 40;

interface ObservacionesFieldProps {
  currentItem: ItemOfertaData;
  handleItemChange: (field: keyof ItemOfertaData, value: string | number) => void;
}

export const ObservacionesField: React.FC<ObservacionesFieldProps> = ({
  currentItem,
  handleItemChange,
}) => {
  return (
    <Grid size={{ xs: 12, md: 4 }}>
      <TextField
        label="Observaciones"
        fullWidth
        value={currentItem.observaciones}
        onChange={(e) =>
          handleItemChange(
            'observaciones',
            e.target.value.slice(0, OBSERVACIONES_MAX_LENGTH),
          )
        }
        slotProps={{
          htmlInput: {
            maxLength: OBSERVACIONES_MAX_LENGTH,
          },
          formHelperText: {
            sx: { textAlign: 'right', mr: 0 },
          },
        }}
        helperText={`${currentItem.observaciones.length}/${OBSERVACIONES_MAX_LENGTH}`}
      />
    </Grid>
  );
};
